<template>
    <div>
        <div class="form-group">
            <div class="row no-gutter">
                <div class="col-md-5">
                    <label>How did you hear about the program?</label>
                </div>
                <div class="col-md-7" v-bind:class="{'has-error': errors.has('how_you_heard')}">
                    <select class="form-control"
                        name="how_you_heard"
                        v-model="how_you_heard"
                        data-vv-name="how_you_heard"
                        v-validate="'required'"
                    >
                        <option value="">-- Please select an option --</option>
                        <option value="email">Email</option>
                        <option value="event">Event</option>
                        <option value="friend">From a Friend</option>
                        <option value="mail">Mail</option>
                        <option value="social_media">Social Media</option>
                        <option value="other">Other</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="form-group">
            <div class="row no-gutter">
                <div class="col-md-5">
                    <label>I am buying as a:</label>
                </div>
                <div class="col-md-7">
                    <div class="row marketing-information">
                        <div class="col-sm-6">
                            <div class="checkbox-item">
                                <input type="checkbox" class="check-style" id="buying_as_alumnus_alumna" v-model="buying_as" value="alumnus_alumna">
                                <label for="buying_as_alumnus_alumna">Alumnus/Alumna</label>
                            </div>
                            <div class="checkbox-item">
                                <input type="checkbox" class="check-style" id="buying_as_emeritus_emerita" v-model="buying_as" value="emeritus_emerita">
                                <label for="buying_as_emeritus_emerita">Emeritus/Emerita</label>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="checkbox-item">
                                <input type="checkbox" class="check-style" id="buying_as_employee" v-model="buying_as" value="employee">
                                <label for="buying_as_employee">Employee</label>
                            </div>
                            <div class="checkbox-item">
                                <input type="checkbox" class="check-style" id="buying_as_friend" v-model="buying_as" value="friend">
                                <label for="buying_as_friend">Friend</label>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="checkbox-item">
                                <input type="checkbox" class="check-style" id="buying_as_parent_or_family_member" v-model="buying_as" value="parent_or_family_member">
                                <label for="buying_as_parent_or_family_member">Parent or Family Member</label>
                            </div>
							<div class="checkbox-item">
                                <input type="checkbox" class="check-style" id="buying_as_other" v-model="buying_as" value="other">
                                <label for="buying_as_other">Other</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/jsx">
    export default {
        name: 'marketing-information',
        data: function () {
            return this.getDefaultData();
        },
        computed: {
            // errors: {}
        },
        methods: {
            getDefaultData: function () {
                // to provide original defaults only once
                return Object.assign({},
                    {
                        how_you_heard: '',
                        buying_as: []
                    },
                    this.$store.getters.marketing
                );
            }
        }
    }
</script>

<style lang="scss" scoped>
    .marketing-information {
        .checkbox-item {
            display: block;
            padding-left:0;
        }
    }
</style>



// WEBPACK FOOTER //
// MarketingInformation.vue?4244fc2c